<div class="tradingview-widget-container">
    <div class="tradingview-widget-container__widget"></div>
    <div class="tradingview-widget-copyright"><a href="https://www.tradingview.com/symbols/TSLA/" rel="noopener" target="_blank">
            <span class="blue-text">{{ this.symbol }}</span></a> by TradingView</div>
    <div #tradingview></div>
</div>